import { Button, Card, Form, Input, Modal, notification, Typography } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { REPLACEMENT_TEXT, ROUTES } from '@/constants';
import { createApiClientWithToken } from '@/service/PreRegistrationApiFactory';

interface FormValues {
  title: string;
  body: string;
}

const api = createApiClientWithToken();

const SendEmailToAllPage: React.FC = () => {
  const history = useHistory();
  const [form] = Form.useForm<FormValues>();

  const [isSendingMail, setIsSendingMail] = useState(false);

  const showConfirm = async () => {
    try {
      await form.validateFields();
    } catch (errors) {
      return;
    }

    Modal.confirm({
      title: '全登録者にメールが送信されますが、よろしいですか？',
      onOk() {
        form.submit();
      },
    });
  };

  const handleFinish = async (values: FormValues) => {
    setIsSendingMail(true);

    await api
      .sendEmailToAll({
        body: {
          title: values.title,
          body: values.body,
        },
      })
      .then(() => {
        notification.success({
          message: 'メールの送信に成功しました',
        });
        setTimeout(() => history.push(ROUTES.topGacha), 500);
      })
      .catch(() => {
        notification.error({
          message: 'メールの送信に失敗しました',
          description: `エンジニアまで確認をお願いします。`,
        });
      });
    setIsSendingMail(false);
  };

  return (
    <Card title={<Typography.Title level={4}>全登録者へのメール送信画面</Typography.Title>}>
      <Form form={form} onFinish={handleFinish} labelCol={{ span: 5 }} wrapperCol={{ span: 14 }}>
        <Form.Item label="メールの件名" name="title" rules={[{ required: true, message: '件名を入力してください' }]}>
          <Input disabled={isSendingMail} />
        </Form.Item>

        <Form.Item
          label="メールの本文"
          name="body"
          rules={[{ required: true, message: '本文を入力してください' }]}
          extra={
            <div>
              【置換文字】
              <br />
              {REPLACEMENT_TEXT.NICKNAME} ：登録者のユーザ名
              <br />
              {REPLACEMENT_TEXT.MAIL_ADDRESS} ：登録者のメアド
            </div>
          }
        >
          <Input.TextArea rows={10} disabled={isSendingMail} />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 5, span: 14 }}>
          <Button type="primary" onClick={showConfirm} disabled={isSendingMail}>
            送信
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SendEmailToAllPage;
